import React, { FC } from "react";
import logoImage from "../logo.svg";

const Logo: FC<{ width?: string }> = ({ width = "20px" }) => {
  return <img src={logoImage} alt="Jay Bird's" style={{ width }} />;
};

export default Logo;
